import Box from "./Box";
import { ExternalTextLink } from "./Links";

export default function ResultExplanation({ display }) {
  return (
    <Box display={display} fontSize={[14, 14, 16]} textAlign="center">
      Your Regenerus results are based on optimal biomarker ranges which differ from standard lab
      ranges{" "}
      {
        <ExternalTextLink href="https://omnos.me/articles/understanding-your-omnos-results">
          learn more
        </ExternalTextLink>
      }
    </Box>
  );
}
